export default __webpack_public_path__ + "static/media/ApplicationForm.4b247efb.svg";